<template>
  <v-list-item dense class="list-item" @click="click">
    <v-list-item-title class="list-item-text">
      <v-icon v-if="icon" class="mr-4 uikit-icon" :class="icon" :title="title" />
      <span>{{ title }}</span>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItemButton',

  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },

  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>
